import { useMemo } from 'react';
import { TDocumentListItem } from '../types/Documents';
import { useHistoryDocuments } from './useHistoryDocuments';
import { useTelemonitoringReports } from './useTelemonitoringReports';
import { useAppointmentReports } from './useAppointmentReports';

export const usePatientHistoryItems = (
  pathwayId: string,
  createdAtRanges?: string[] | null,
) => {
  const documents = useHistoryDocuments(pathwayId, createdAtRanges);
  const reports = useTelemonitoringReports(pathwayId, createdAtRanges);
  const appointmentReports = useAppointmentReports(createdAtRanges);

  const items: TDocumentListItem[] = useMemo(
    () => [
      ...documents.documents.map(d => ({ kind: 'document' as const, data: d })),
      ...reports.reports.map(r => ({ kind: 'report' as const, data: r })),
      ...appointmentReports.appointmentReports.map(r => ({
        kind: 'appointment-report' as const,
        data: r,
      })),
    ],
    [documents.documents, reports.reports, appointmentReports.appointmentReports],
  );

  const isLoading =
    documents.isLoading || reports.isLoading || appointmentReports.isLoading;
  const isRefetching =
    documents.isRefetching || reports.isRefetching || appointmentReports.isRefetching;

  const refetch = () => {
    documents.refetch();
    reports.refetch();
    appointmentReports.refetch();
  };

  return { items, isLoading, isRefetching, refetch };
};
